import { combineReducers } from "redux";

import benchmarkEntityReducer from "./reducers/benchmarkEntityReducer/reducer";
import report from "./reducers/report/reportReducer";
import type { BenchmarkStateTypes } from "./types";

const benchmarkReducer = combineReducers<BenchmarkStateTypes>({
    benchmarkEntityReducer,
    report,
});

export default benchmarkReducer;
